<mat-dialog-content>
  <div class="option-choice-container">
    <h4>{{ data.confirmationText }}</h4>
    <div class="buttons-container">
      <button mat-stroked-button color="primary" (click)="onDecline()">No</button>
      <button mat-stroked-button color="warn" (click)="onConfirm()">Yes</button>
    </div>
  </div>
</mat-dialog-content>
